module.exports = __webpack_public_path__ + "static/img/WB671-PF_A.8175fff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/WB671-PF_A.jpg
// module id = l/2I
// module chunks = 0